import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updatePost($id: String!, $text: String!, $imageIds: [String]) {
    updatePost(id: $id, text: $text, imageIds: $imageIds) {
      post {
        id
      }
    }
  }
`

export interface UpdatePostInput {
  id: string
  text: string
  imageIds: string[]
}

export interface UpdatePostOutput {
  updatePost: {
    post: {
      id: string
    }
  }
}

export const useUpdatePost = () => useMutation<UpdatePostOutput, UpdatePostInput>(mutation)
